/**
 * Created by piotr.pozniak@thebeaverhead.com on 09/05/2023
 */

import { useMemo } from "react";

/**
 *
 * @param {Object} filter
 * @param {Object }rule
 * @returns {*}
 * @constructor
 */
const RuleLabel = ({ filter, rule }) => {
  const label = useMemo(() => {
    if (typeof filter?.fieldComponent === "function") {
      return filter.fieldComponent(rule);
    }

    return filter?.field?.label || "Unknown Field";
  }, [filter, rule]);

  return label;
};

export default RuleLabel;
